import Phaser from "phaser";
import { BOARD_TEXTURES } from "../assets";
import { multiplayer } from "../multiplayer";
import { setGameStatus } from "../status";
import { STAGE } from "../view/stage";
import { menuIcon } from "../view/menuIcons";

export class LobbyScene extends Phaser.Scene {
  private panel?: HTMLElement;
  private unsubscribe?: () => void;
  private selecting = false;
  private enterName = false;
  constructor() { super("LobbyScene"); }
  init(data?: { enterName?: boolean }): void { this.enterName = Boolean(data?.enterName); this.selecting = false; }
  create(): void {
    this.add.image(STAGE.width / 2, STAGE.height / 2, BOARD_TEXTURES.backdrop).setDisplaySize(STAGE.width, STAGE.height);
    this.add.rectangle(STAGE.width / 2, STAGE.height / 2, STAGE.width, STAGE.height, 0x102d2b, 0.65);
    const panel = document.createElement("section"); panel.className = "online-menu"; this.panel = panel;
    document.querySelector("#app-shell")?.append(panel);
    this.unsubscribe = multiplayer.subscribe(event => {
      if (event.type === "state") this.enterMatch();
      else if (["lobby", "connection", "left", "error"].includes(event.type) && !this.enterName) this.drawLobby();
    });
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => { this.unsubscribe?.(); this.panel?.remove(); });
    if (this.enterName) this.drawNameForm(); else { this.drawLobby(); this.enterMatch(); }
  }
  private enterMatch(): void {
    const match = multiplayer.match;
    if (!match) return;
    if (!match.own.run) this.scene.start("StartScene", { online: true });
    else this.scene.start(match.own.run.phase === "battle" ? "BattleScene" : "BoardScene", { run: match.own.run, online: true });
  }
  private drawNameForm(): void {
    this.panel!.innerHTML = `<h2>Play together</h2><form class="online-name-form"><label for="online-name">Your name</label><input id="online-name" name="name" maxlength="24" autocomplete="nickname" required placeholder="What should we call you?"><button type="submit" class="online-primary">${menuIcon("join")}<span>Join lobby</span></button></form><button type="button" class="online-back">${menuIcon("back")}<span>Back</span></button>`;
    this.panel!.querySelector("form")!.addEventListener("submit", event => {
      event.preventDefault(); const input = this.panel!.querySelector<HTMLInputElement>("input")!;
      const name = input.value.trim(); if (!name) return;
      this.enterName = false; multiplayer.join(name); this.drawLobby();
    });
    this.panel!.querySelector(".online-back")!.addEventListener("click", () => this.back());
    this.panel!.querySelector<HTMLInputElement>("input")!.focus();
    setGameStatus("ready", "Enter your name to play multiplayer.");
  }
  private drawLobby(): void {
    if (!this.panel) return;
    this.panel.innerHTML = `<h2>Choose your challenger</h2><p class="online-lobby-status"></p><div class="online-lobby-players"></div><button type="button" class="online-back">${menuIcon("back")}<span>Back</span></button>`;
    const status = this.panel.querySelector<HTMLElement>(".online-lobby-status")!;
    const list = this.panel.querySelector<HTMLElement>(".online-lobby-players")!;
    const players = multiplayer.lobbyPlayers.filter(player => player.id !== multiplayer.playerId);
    status.textContent = multiplayer.error ?? (multiplayer.status !== "connected" ? "Connecting to the party…" : players.length ? "Pick a name to enter the game together." : "Waiting for another player…");
    for (const player of players) {
      const button = document.createElement("button"); button.type = "button"; button.className = "online-lobby-player";
      button.disabled = this.selecting || multiplayer.status !== "connected";
      const glyph = document.createElement("span"); glyph.innerHTML = menuIcon("play"); glyph.setAttribute("aria-hidden", "true");
      const name = document.createElement("span"); name.className = "online-lobby-name"; name.textContent = player.name;
      button.append(glyph, name);
      button.addEventListener("click", () => {
        this.selecting = true; this.drawLobby();
        void multiplayer.challenge(player.id).catch(error => { this.selecting = false; multiplayer.fail(error.message); this.drawLobby(); });
      });
      list.append(button);
    }
    this.panel.querySelector(".online-back")!.addEventListener("click", () => this.back());
    setGameStatus(multiplayer.error ? "error" : "ready", status.textContent);
  }
  private back(): void { multiplayer.leave(); this.scene.start("StartScene", { menu: true }); }
}
